
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import './index.scss';
import InfiniteScroll from 'react-infinite-scroller';
import { pastReq, taskReq, alertShow } from '@/store/actions'
import { setTopBar, setMenu } from '@/utils/jrSdk'
import { GetRequest } from '@/utils';
import ComBtn from '@/components/comBtn';
import ComTag from '@/components/comTag';
import classnames from 'classnames';
function Past() {
    const { isBai ,btUrl }  = useSelector(state => state.base);
    const [channelCode, setChannelCode] = useState(GetRequest('channelCode'));
    const [parentTaskCode, setParentTaskCode] = useState(GetRequest('parentTaskCode'));
    const [hasMore, SetHasMore] = useState(true);
    const { list, pageNo, end } = useSelector(state => state.past);
    const dispatch = useDispatch();
    useEffect(() => {
        setTopBar({title: '往期任务列表'})
        setMenu({isShow: false})
        getMore()
    }, [])
    function getMore() {
        if(end) return ;
        dispatch(pastReq({ channelCode: channelCode, parentTaskCode: parentTaskCode, sortType: 1, pageNo: pageNo}));
    }
    function handleBtn(info) {
        const btText = {
            title: '需要开通白条才能参加活动哦~',
            btnText: '我知道了',
            action: () => window.locationTo({ url: btUrl })
        }
        switch(info.realStatus) {
            case 'ac0': {
                if(isBai) dispatch(taskReq({ channelCode: channelCode, taskCode: info.taskCode }));
                else dispatch(alertShow(btText))
            };break;
            case 'ac1':
            case 'ac2':
            case 'fr2':
            case 'rw2':
            case 'rw4':
                window.locationTo({
                    url: '/home',
                    params: {
                        channelCode,
                        taskCode: info.taskCode
                    }
                });
                break
        }
    }
    return (
        <div className='past-list'>
             {list && list.length?<InfiniteScroll
                pageStart={0}
                loadMore={getMore}
                hasMore={hasMore}
                loader=''
            >
                {
                    list.map((it, idx) => <Item info={it} key={idx} handleBtn={handleBtn}/>)
                }
            </InfiniteScroll>:
             list && 
             list.length === 0 &&
             end === true ?
             <div className='cost-no'>暂无数据~</div> :
             <div className='cost-no'>加载中</div>
             }
            {
                end?<ComTag title='京东金融'></ComTag>: null
            }
            
        </div>
    )
}

const Item = React.memo(function ({
    info,
    handleBtn
}) {
    const dispatch = useDispatch();
    let [rate, setRate] = useState(null);
    useEffect(() => {
        switch(info.realStatus) {
            case 'ac1':
            case 'ac2':
            case 'fr1':
            case 'fr2': 
            case 'rw1':
            case 'ou1':
            case 'ou2':
            case 'ou4':
                setRate(<div className='past-item-rate'>已完成{info.rate}%</div>);
                break;
            case 'rw2':
                setRate(<div className='past-item-rate past-item-red'>{info.rewardEndTimeText}</div>)
                break;
        }   
    }, [])
    console.log(info)
    return (
        <div className='past-item-box'>
            <div className='past-title'>第<span>{info.stageNumber}</span>期</div>
            <div className='past-content'>
                <div className='past-content-left'>
                    <div className='past-left-content'>{ info.isOverTitle }</div>
                    <div className='past-left-time'>{info.homeTitleText}: {info.showTime}</div>
                </div>
                <div className={classnames('past-content-right', rate?'': 'past-right-bot')}>
                    <ComBtn handleBtn={handleBtn.bind(null, info)} info={info}></ComBtn>
                    { rate }
                </div>
            </div>
        </div>
    )
})

export default React.memo(Past);